export default __webpack_public_path__ + "media/images/gift_fund/paypal-cc8ca8e0eb3a0a2a2edc49d062dc71f6.svg";